import Card from "@/components/Card";
import { SdgGoalResult } from "@/schema/console/evaluation-reports/SdgGoalResult";
import AchievementItem from "@/src/console/(auth)/_components/EvaluationReport/AchievementCard/AchievementItem";
import { useTranslation } from "react-i18next";

interface AchievementCardProps {
  score: number;
  sdgGoalResults: SdgGoalResult[];
}

function AchievementCard({ score, sdgGoalResults }: AchievementCardProps) {
  const { t } = useTranslation();
  return (
    <Card>
      <div className=" flex flex-col">
        <p className=" text-lg font-medium text-cool-gray-900 px-6 py-5">
          {t("achievement-of-sDGs")}
        </p>
        <div className=" flex flex-row space-x-6 px-6 pb-5">
          <div className=" flex flex-col space-y-2 px-6 py-4 rounded-lg bg-cool-gray-50">
            <p className=" text-4xl font-medium text-cool-gray-700">
              {score} %
            </p>
            <p className=" text-sm font-medium text-cool-gray-600">{t("achieved")}</p>
          </div>
          <div className=" flex flex-col border-l border-l-cool-gray-200 pl-6 justify-between">
            <p className=" text-sm font-medium text-cool-gray-600">
              {t("achievement-of-each-sDGs-goal")}
            </p>
            <div className=" flex flex-row space-x-6">
              {sdgGoalResults.map((sdgGoalResult, index) => (
                <AchievementItem key={index} sdgGoalResult={sdgGoalResult} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
}

export default AchievementCard;
